import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { kuangjiApi } from "../../api/kuangm-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import EndList from "./components/endList";
import RunList from "./components/runList";
import Tabs from "./components/tabs";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function LockUpOrder() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(1);
  const uid = localStorage.getItem("uid");
  const [userkjList, setUserKjList] = useState([] as any[]);
  const { t: translate } = useTranslation();

  //用户kj 列表
  const loadUserKJListData = async () => {
    const data = await kuangjiApi.uidList({ uid });
    if (data.ok) {
      setUserKjList(data.data);
    }
  };
  useEffect(() => {
    loadUserKJListData();
  }, [index]);
  return (
    <div className="w-full min-h-dvh bg-neutral-900 revert-style">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={translate(getText("委託訂單"))}
        pcTopBarTitle={translate(getText("委託訂單"))}
      >
        <div className="flex flex-col container mx-auto px-4 md:px-6">
          <div className="bg-neutral-800 rounded-lg shadow-card mt-4 overflow-hidden">
            <div className="border-b border-neutral-700">
              <Tabs index={index} setIndex={setIndex} />
            </div>
            
            <div className="py-2">
              {index === 1 && (
                <div className="animate-fade-in">
                  <RunList userkjList={userkjList} />
                </div>
              )}
              {index === 2 && (
                <div className="animate-fade-in">
                  <EndList userkjList={userkjList} />
                </div>
              )}
            </div>
          </div>
          
          <div className="h-20 md:h-10"></div>
        </div>
      </AcendexLayout>
    </div>
  );
}
